import { Camada } from '@/componentes/celula';
import { RotuloValor, Valor, type TomValor } from '@/componentes/valor';

import type { Cobertura } from './cobertura';
import type { ResumoHistorico } from './resumo';

/* O fechamento do que foi digitado: o que os meses informados projetam para o
   ano. Areia porque constata, não opina. */

function tomDoPeso(peso: number | null): TomValor {
  if (peso === null) return 'apagado';
  if (peso > 0.3) return 'negativo';
  if (peso > 0.2) return 'atencao';
  return 'positivo';
}

export function Fechamento({
  cobertura,
  resumo,
}: {
  cobertura: Cobertura;
  resumo: ResumoHistorico;
}) {
  const { parametros, totalProjetos } = resumo;
  const parcial = cobertura < 12;

  return (
    <Camada className="bg-areia grid gap-4">
      <span className="titulo-bloco">
        {parcial
          ? `Projeção anualizada, ${cobertura} meses de histórico`
          : 'Fechamento dos 12 meses'}
      </span>

      {parcial && totalProjetos > 0 ? (
        <p className="text-apoio">
          {cobertura} meses informados, <Valor valor={totalProjetos} formato="inteiro" />{' '}
          {totalProjetos === 1 ? 'projeto' : 'projetos'}. Projeção de{' '}
          <Valor valor={parametros.V12} formato="numero" /> projetos por ano.
          {parametros.ticketMedioSaz > 0 ? (
            <>
              {' '}
              Ticket médio <Valor valor={parametros.ticketMedioSaz} formato="moeda" />.
            </>
          ) : null}
        </p>
      ) : null}

      <div className="grid gap-4 @campos:grid-cols-3">
        <RotuloValor
          rotulo="Ticket médio"
          valor={parametros.ticketMedioSaz > 0 ? parametros.ticketMedioSaz : null}
          formato="moeda"
          tamanho="sub"
          nota="Total faturado dividido pelo total de projetos"
        />
        <RotuloValor
          rotulo="Faturamento médio mensal"
          valor={resumo.faturamentoMedio}
          formato="moeda"
          tamanho="sub"
          nota={`Total faturado dividido por ${cobertura} meses`}
        />
        <RotuloValor
          rotulo="Peso da despesa fixa"
          valor={resumo.pesoDaFixa}
          formato="percentual"
          tamanho="sub"
          tom={tomDoPeso(resumo.pesoDaFixa)}
          nota={
            parametros.despFixa > 0
              ? 'Despesa fixa mensal dividida pelo faturamento médio'
              : 'Informe a despesa fixa mensal na etapa Despesas.'
          }
        />
      </div>
    </Camada>
  );
}
